import { AlertCircle, RefreshCw } from "lucide-react"
import { Button } from "@/components/ui/button"

interface PageErrorProps {
  error?: Error | null
  resetErrorBoundary?: () => void
}

export function PageError({ error, resetErrorBoundary }: PageErrorProps) {
  return (
    <div className="flex h-full min-h-[400px] items-center justify-center p-6">
      <div className="w-full max-w-md rounded-[var(--radius-panel)] border border-[var(--color-border-subtle)] bg-[var(--color-bg-secondary)] p-8">
        <div className="flex flex-col items-center gap-4 text-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[var(--color-accent-red)]/10">
            <AlertCircle className="h-6 w-6 text-[var(--color-accent-red)]" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-[var(--color-text-primary)]">
              Something went wrong
            </h2>
            <p className="mt-1 text-sm text-[var(--color-text-secondary)]">
              {import.meta.env.DEV && error
                ? error.message
                : "An unexpected error occurred. Please try again."}
            </p>
          </div>
          <Button
            onClick={() => {
              if (resetErrorBoundary) {
                resetErrorBoundary()
              } else {
                window.location.reload()
              }
            }}
            variant="secondary"
            size="sm"
          >
            <RefreshCw className="h-4 w-4" />
            Try again
          </Button>
        </div>
      </div>
    </div>
  )
}
